<!-- HEADER -->
<div class="page-title-bar mb-4" style="align-items: center">
  <div class="customer_flexc" style="align-items: center">
    <div class="title d-flex" style="align-items: center">
      <div class="custgomner_wallet">
        <button mat-icon-button class="me-3" (click)="gotoback()">
          <mat-icon class="material-icons-round">arrow_back</mat-icon>
        </button>
      </div>
      <div>
        <div class="rt_tht">
          <h1>{{mn}} Reward points</h1>
        </div>
      </div>
    </div>

  <div class="add_brtnfh">
<button
  mat-icon-button
  color="accent"
  [matMenuTriggerFor]="walletMenu">
  <mat-icon class="material-icons-round">more_vert</mat-icon>
</button>

<mat-menu #walletMenu="matMenu" class="wallet-menu">
  <button mat-menu-item [disabled]="rewardTransactionData.length == 0" (click)="transferToWallet()">
    <mat-icon class="material-icons-outlined">
      account_balance_wallet
    </mat-icon>
    <span>Transfer to wallet</span>
  </button>
</mat-menu>

  </div>


  </div>
</div>
<!-- SUMMARY -->
<div *ngIf="!loader">
  <div class="bradcamp_inventory">
    <div class="over_sectionkl">
      <div class="overall_count_s">
        <p>Total</p>
        <h3>{{ rewardData.total }} points</h3>
      </div>
      <div
        class="overall_count_s no-border"
        style="margin-right: 0px; border-right: 0px"
      >
        <p>This month</p>
        <h3>{{ rewardData.monthly }} points</h3>
      </div>
    </div>
  </div>
  <!-- WALLET TRANSACTIONS -->
  <div class="expenjkad" *ngIf="rewardTransactionData.length > 0">
    <div class="row">
      <div class="col-sm-4" *ngFor="let item of rewardTransactionData">
        <mat-card>
          <div class="package-card">
            <div class="package-header">
              <div class="package-price">
                {{ item.reward_points }}
              </div>
            </div>
            <!-- <div class="package-date">
              <span class="main_activert" style="padding-left: 0px">
                Type
              </span>
            </div> -->
            <div class="package-date">
              <span class="main_activert" style="padding-left: 0px">
                {{item.notes}}
              </span>
            </div>
            <div class="reda_lp">
              <p style="display: flex; align-items: center; color: #888">
                <span class="status_active" *ngIf="item.tx_status == 'Active'"></span> 
                <span class="status_inactive" *ngIf="item.tx_status == 'Expired'"></span> 
                <span class="status_refunded" *ngIf="item.tx_status == 'Transferred to wallet'"></span> 
                
                {{item.tx_status}}<span *ngIf="item.tx_status == 'Active' || item.tx_status == 'Expired'">, {{item.tx_status == 'Active' ? ('Expiring on ' + item.exp_date) : ('Expired on ' + item.exp_date) }}</span>
              </p>
            </div>
            <div class="rewadf_lili">
              <div class="package-title">{{ item.created_at | date : 'MMM d, y, h:mm a' : 'UTC' }}</div>
            </div>
          </div>
        </mat-card>
      </div>
    </div>
  </div>

   <div class="" *ngIf="rewardTransactionData.length == 0">
    <div class="row">
      <div class="col-sm-12">
        <div class="svg_cont">
          <div class="booking_img_placeholder">
            <img src="../../../../assets/images/reward_points_placeholder.png"/>
          </div>
          <div class="h2_cont">
            <!-- <h2>
              It seems like your wallet is empty. <br />
              Go for appoitments and get the best deal in the market.
            </h2> -->

            <h2>There's no reward point transactions happened. Current reward balance and transactions will show here once it's started.</h2>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
